// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Col } from "@components";
import { SchemaForm } from "@components";
import type { PropertiesSchema } from "@types";
import uiSchema from "./ui-schema";
import type { EmployeeType } from "@modules/employee/types";

type Props = {
  onDismissHandler: () => void,
  onSubmit: (form: Object) => void,
  schema: ?PropertiesSchema,
  submitButtonText: string,
  submitButtonIcon: string,
  title: string,
  formData: Object | null,
  employee: ?EmployeeType,
  ...PropsFromLocalize,
};

export class AddEditEmployeePositionModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (formData: Object) => {
    this.props.onSubmit(formData);
  };

  get uiSchema() {
    return {
      ...uiSchema,
      activeFrom: {
        ...uiSchema.activeFrom,
        ["ui:options"]: {
          ...uiSchema.activeFrom["ui:options"],
          minDate: (this.props.employee || {}).dateOfBirth,
        },
      },
      organisationalUnit: {
        ...uiSchema.organisationalUnit,
        "ui:options": {
          searchPlaceholder: this.props.t("SEARCH_DEPARTMENT"),
          searchable: true,
          inputPlaceholder: this.props.t("SELECT_DEPARTMENT"),
          modalTitle: this.props.t("SELECT_DEPARTMENT"),
          cancelButtonTitle: this.props.t("CANCEL"),
          submitButtonTitle: this.props.t("SUBMIT"),
        },
      },
    };
  }

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.props.onDismissHandler}>{this.props.title}</ModalHeader>
        <ModalBody>
          <SchemaForm
            ref={this.formRef}
            schema={this.props.schema}
            uiSchema={this.uiSchema}
            formData={this.props.formData}
            onSubmit={this.handleSubmit}
            externalSubmit
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon={this.props.submitButtonIcon} onClick={this.submitForm}>
            {this.props.submitButtonText}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(AddEditEmployeePositionModal);
